import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { GET_IPS_VIOLATION_POINTS } from "../../queries/ipsAdminQrys";
import {
  Table,
  TableBody,
  TableBodyData,
  TableBodyDataCellTemplate,
  TableBodyDataRowTemplate,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  TablePagination,
  TableWrapper,
  TableFilterTextInput,
  TableFilters,
  TableSortingRules,
  TableSortingRule,
  Button
} from '@utahdts/utah-design-system';

const IPSViolationAdmin = () => {

  const { data } = useQuery(GET_IPS_VIOLATION_POINTS);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (data?.getIPSViolationPoints) {
      const formattedData = data.getIPSViolationPoints.map((item) => ({
        ...item,
        violationTypeDisplay: `${item.violationType.type} ${item.violationType.name}`.trim(),
        analyteName: item.analyte?.name || '',
        ipsPoints: String(item.ipsPoints),
      }));
      setTableData(formattedData);
    }
  }, [data]);

  return (
    <div className="utah-design-system page-container">
      <h3>IPS Violations Admin</h3>
      <br />
      <Button variant="primary" className="mb-spacing">Add New</Button>
      {tableData.length > 0 && (
        <TableWrapper>
          <Table>
          <TableHead>
            <TableSortingRules>
              <TableSortingRule allyLabel="Sort by Violation Type" recordFieldPath="violationTypeDisplay" />
              <TableSortingRule allyLabel="Sort by Analyte/Analyte Group" recordFieldPath="analyteName" />
              <TableSortingRule allyLabel="Sort by Rule Reference" recordFieldPath="ruleReference" />
              <TableSortingRule allyLabel="Sort by Points" recordFieldPath="ipsPoints" />
              <TableSortingRule allyLabel="Sort by Return to Compliance Method" recordFieldPath="returnToComplianceMethod" />
              <TableSortingRule allyLabel="Sort by Last Updated" recordFieldPath="lastUpdatedDate" />
            </TableSortingRules>
            <TableHeadRow>
              <TableHeadCell recordFieldPath="violationTypeDisplay">Violation Type</TableHeadCell>
              <TableHeadCell recordFieldPath="analyteName">Analyte/Analyte Group</TableHeadCell>
              <TableHeadCell recordFieldPath="ruleReference">Rule Reference</TableHeadCell>
              <TableHeadCell recordFieldPath="ipsPoints">Points</TableHeadCell>
              <TableHeadCell recordFieldPath="returnToComplianceMethod">Return to Compliance Method</TableHeadCell>
              <TableHeadCell recordFieldPath="lastUpdatedDate">Last Updated</TableHeadCell>
              <TableHeadCell recordFieldPath="edit"></TableHeadCell>
            </TableHeadRow>
            <TableFilters>
              <TableFilterTextInput a11yLabel="Filter by Violation Type" recordFieldPath="violationTypeDisplay" placeholder={'filter'}/>
              <TableFilterTextInput a11yLabel="Filter by Analyte/Analyte Group" recordFieldPath="analyteName" placeholder={'filter'}/>
              <TableFilterTextInput a11yLabel="Filter by Rule Reference" recordFieldPath="ruleReference" placeholder={'filter'}/>
              <TableFilterTextInput a11yLabel="Filter by Points" recordFieldPath="ipsPoints" placeholder={'filter'}/>
              <TableFilterTextInput a11yLabel="Filter by Return to Compliance Method" recordFieldPath="returnToComplianceMethod" placeholder={'filter'}/>
              <TableFilterTextInput a11yLabel="Filter by Last Updated" recordFieldPath="lastUpdatedDate" placeholder={'filter'}/>
              <TableHeadCell></TableHeadCell>
            </TableFilters>
          </TableHead>
          <TableBody>
            <TableBodyData records={tableData} recordIdField="violationId">
              <TableBodyDataRowTemplate>
                <TableBodyDataCellTemplate recordFieldPath="violationTypeDisplay" />
                <TableBodyDataCellTemplate recordFieldPath="analyteName" />
                <TableBodyDataCellTemplate recordFieldPath="ruleReference" />
                <TableBodyDataCellTemplate recordFieldPath="ipsPoints" />
                <TableBodyDataCellTemplate recordFieldPath="returnToComplianceMethod" />
                <TableBodyDataCellTemplate recordFieldPath="lastUpdatedDate" />
                <TableBodyDataCellTemplate >Edit Delete</TableBodyDataCellTemplate>
              </TableBodyDataRowTemplate>
            </TableBodyData>
          </TableBody>
          </Table>
          <TablePagination
            className="mt-spacing"
            id="table-example-render-pagination-id"
            itemsPerPage={25}
          />
        </TableWrapper>
      )}
    </div>
  );
}

export default IPSViolationAdmin;